import { useState } from "react";
import { CardThree } from "../../components/cards/cardThree";
import styles from "./controllerSelect.module.css";
import { Options } from "../../components/options/options";
import { Option } from "../../components/options/option";
import { toast } from "react-toastify";
import { toastOptions } from "../../utilities/utilities";

export const ControllerSelect = ({
      joystickIndex,
      previousGamepadLoop,
      bindingValue,
      joystick,
      game,
}) => {
      const [showOptions, setShowOptions] = useState(false);
      const [showBottom, setShowBottom] = useState(true);
      const settingClickHandler = (event) => {
            event.stopPropagation();
            game.sounds.clickSound.play();
            const positions = event.currentTarget.getBoundingClientRect();
            if (positions.top < window.innerHeight / 2) {
                  setShowBottom(true);
            } else {
                  setShowBottom(false);
            }
            setShowOptions(true);
      };

      let assignedButtonName = null;
      for (let i = 0; i < joystick.defaultKeyBindings.length; i++) {
            if (joystick.defaultKeyBindings[i] === bindingValue) {
                  assignedButtonName = joystick.buttonsNames[i];
            }
      }

      let temporary = bindingValue;
      if (temporary === "ArrowDown") {
            temporary = "down";
      } else if (temporary === "ArrowLeft") {
            temporary = "left";
      } else if (temporary === "ArrowRight") {
            temporary = "right";
      }

      const optionsClickHandler = (event, currentGamePadLoopState) => {
            event.stopPropagation();
            const buttonIndex = event.target.getAttribute("data-button-index");
            const joystickIndex = event.currentTarget.getAttribute(
                  "data-joystick-index"
            );
            const bindingValue =
                  event.currentTarget.getAttribute("data-binding-value");

            if (
                  game.joysticks[joystickIndex].updateGameKeyBinding(
                        buttonIndex,
                        bindingValue
                  )
            ) {
                  game.userSavedData.settings.controls.controller[
                        joystickIndex
                  ] = game.joysticks[joystickIndex].defaultKeyBindings;
                  game.saveData();
                  game.sounds.clickSound.play();
                  setShowOptions(false);
                  currentGamePadLoopState.run = false;
                  previousGamepadLoop.gamepadLoopState.run = true;
                  previousGamepadLoop.setStartGamePadLoop(true);
            } else {
                  toast.error("already used", toastOptions);
            }
      };

      return (
            <div className={styles["setting-container"]}>
                  <span>{temporary}</span>
                  <CardThree
                        customClass={styles["setting"]}
                        tabIndex={2}
                        onClick={settingClickHandler}
                        testId="gamepad-select"
                  >
                        {assignedButtonName}

                        {showOptions ? (
                              <Options
                                    previousGamepadLoop={previousGamepadLoop}
                                    game={game}
                                    setShowOptions={setShowOptions}
                                    attributes={{
                                          "data-joystick-index": 0,
                                          "data-binding-value": bindingValue,
                                    }}
                                    clickHandler={optionsClickHandler}
                                    showBottom={showBottom}
                              >
                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "12",
                                          }}
                                    >
                                          dpad up
                                    </Option>

                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "13",
                                          }}
                                    >
                                          dpad down
                                    </Option>
                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "14",
                                          }}
                                    >
                                          dpad left
                                    </Option>

                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "15",
                                          }}
                                    >
                                          dpad right
                                    </Option>

                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "2",
                                          }}
                                    >
                                          x
                                    </Option>
                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "0",
                                          }}
                                    >
                                          a
                                    </Option>
                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "1",
                                          }}
                                    >
                                          b
                                    </Option>
                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "3",
                                          }}
                                    >
                                          y
                                    </Option>
                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "5",
                                          }}
                                    >
                                          r1
                                    </Option>
                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "7",
                                          }}
                                    >
                                          r2
                                    </Option>
                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "4",
                                          }}
                                    >
                                          l1
                                    </Option>
                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-button-index": "6",
                                          }}
                                    >
                                          l2
                                    </Option>
                              </Options>
                        ) : null}
                  </CardThree>
            </div>
      );
};
